const AuthRightSection = ({ heading, subText, image }) => {
    return (
        <div className="hidden md:flex w-1/2 bg-[#173363] text-white flex-col justify-center items-center px-24 py-10">
            <div className="mt-16">
                <h1 className="text-[4rem] font-bold">{heading}</h1>
                <p className="mt-2 text-gray-300 text-[1.6rem] text-center">{subText}</p>
            </div>
            <div className="p-40">
                <img src={image} alt="auth image" />
            </div>
        </div>
    );
};

export default AuthRightSection;
